import Timer from './Timer';
import Game from '../../../Game';
import { TimerType } from '../TimerTypes';
import DateHelper from '../../../Utility/DateHelper';
import { TimerActions } from '../../../State/Timer/TimerActions';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import { AD_COOLDOWN_TIME, ADS_BEFORE_COOLDOWN } from '../../../Constants/Ads';
import { IGameState } from '../../../State/Game/IGameState';

export default class AdCooldownTimer extends Timer {
    public complete(): void {
        PlayerActions.completeAdCooldownTimer();
    }
    public onUpdate(state: IGameState = Game.store.getState()) {
        if (
            state.playerState.progress.adsWatched >= ADS_BEFORE_COOLDOWN &&
            this.getDate() === null
        ) {
            TimerActions.updateTimer({
                timer: TimerType.AD_COOLDOWN,
                time: DateHelper.now,
            });
        }
    }
    public isCompleted(state: IGameState = Game.store.getState()): boolean {
        return (
            DateHelper.now.getTime() - this.getDate(state).getTime() >
            AD_COOLDOWN_TIME
        );
    }

    public getDate(state: IGameState = Game.store.getState()): Date {
        return state.playerState.timers.get(TimerType.AD_COOLDOWN);
    }
}
